"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Manual.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Manual = function Manual(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 164.6 205.2"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Manual Transmission Icon"), _react2.default.createElement("path", {
    className: "manual",
    d: "M150.6 171.7v-53.4c0-6.5-4.4-12.3-9.4-15.6 5.1-3.4 9.4-9.1 9.4-15.6V33.6a17 17 0 1 0-7.7-.5v47.3c0 10.3-1.6 18.1-16.6 17.7H85.8V33.4a17.11 17.11 0 1 0-7.8-.1v64.8H32.9c-10.3 0-12.2-7.4-12.2-17.7v-47a17 17 0 1 0-7.5 0V87c0 6.5 4.4 12.3 9.4 15.6-5.1 3.4-9.4 9.1-9.4 15.6v53.6a16.9 16.9 0 1 0 20.6 16.5 17 17 0 0 0-13.1-16.5v-47c0-10.3 1.9-17.7 12.2-17.7H78v64.8a16.9 16.9 0 1 0 7.8 0v-64.8h40.4c15-.3 16.6 7.4 16.6 17.7v47.3a16.9 16.9 0 1 0 21.7 16.2 16.69 16.69 0 0 0-13.9-16.6zM139.2 17a8.4 8.4 0 1 1 8.4 8.4 8.39 8.39 0 0 1-8.4-8.4zM17 25.4a8.4 8.4 0 1 1 8.4-8.4 8.39 8.39 0 0 1-8.4 8.4zm8.4 162.9a8.4 8.4 0 1 1-8.4-8.4 8.39 8.39 0 0 1 8.4 8.4zm64.9 0a8.4 8.4 0 1 1-8.4-8.4 8.39 8.39 0 0 1 8.4 8.4zM81.9 25.4a8.4 8.4 0 1 1 8.4-8.4 8.39 8.39 0 0 1-8.4 8.4zm65.8 171.3a8.4 8.4 0 1 1 8.4-8.4 8.39 8.39 0 0 1-8.4 8.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Manual;